import { atom } from 'jotai'

export const orderAtom = atom(null)
export const inspectionSectionsAtom = atom(null)

export const isFieldChangeAtom = atom(false)

export const currentSelectedCollaborator = atom([])
